// extracted by mini-css-extract-plugin
export var content = "MobileTabs-module--content--cb687";
export var fadeInAnimation = "MobileTabs-module--fadeInAnimation--e25ff";
export var last = "MobileTabs-module--last--989ef";
export var showLess = "MobileTabs-module--showLess--5ea77";
export var toggleListButton = "MobileTabs-module--toggleListButton--81a87";
export var wrapper = "MobileTabs-module--wrapper--5667d";